import { render, staticRenderFns } from "./GeneralInfoModal.vue?vue&type=template&id=36c742c6"
import script from "./GeneralInfoModal.vue?vue&type=script&lang=js"
export * from "./GeneralInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports